import Vue from 'vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowCircleDown,
  faArrowCircleLeft,
  faArrowCircleUp,
  faCalculator,
  faCaretDown,
  faCaretRight,
  faCheck,
  faCheckSquare,
  faChevronLeft,
  faChevronRight,
  faCopy,
  faExclamationTriangle,
  faFolderOpen,
  faInfoCircle,
  faLongArrowAltRight,
  faPenSquare,
  faPlusCircle,
  faSave,
  faSearch,
  faSignOutAlt,
  faSpinner,
  faTasks,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUserCircle,
  faAngleUp
} from '@fortawesome/free-solid-svg-icons'

// Add the icons to the library
library.add(
  faArrowCircleDown,
  faArrowCircleLeft,
  faArrowCircleUp,
  faCalculator,
  faCaretDown,
  faCaretRight,
  faCheck,
  faCheckSquare,
  faChevronLeft,
  faChevronRight,
  faCopy,
  faExclamationTriangle,
  faFolderOpen,
  faInfoCircle,
  faLongArrowAltRight,
  faPenSquare,
  faPlusCircle,
  faSave,
  faSearch,
  faSignOutAlt,
  faSpinner,
  faTasks,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUserCircle,
  faAngleUp
)

// Register it as a component to the vue instance
Vue.component('font-awesome-icon', FontAwesomeIcon)
